import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useEffect, useState } from 'react';
import { httpApiGetText, httpApiPostText } from '../../../../lib';
import * as env from '../../../../env';
import LocalMsgModalSpinner from "../../../../components/LocalMsgModalSpinner";

const ModalAsignarDestino = (props: {Show: boolean, Title: string, BtnOkName: string, 
    BtnNokName: string, HandlerClickOk: any, HanlerdClickNok: any, formData: any, 
    NroSolicitud: number, DestinoId: number}) => {

    const [icn] = useState("success");
    let [destinos, setDestinos] = useState<any>([]);     
    let [cmbDestino, setCmbDestino] = useState<any>("");     
    const [sHCarga, setSHCarga] = useState(false);        

    const consultaDestino = async () =>{

        //setea el combo destino 
        cmbDestino = props.DestinoId;
        setCmbDestino(cmbDestino); 

        const recurso = `${env.REACT_APP_API_URL}/api/Mermas?Pais=CL`;
        const response = await httpApiGetText(recurso,{
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        });
       
        const arrDta = await JSON.parse(response.message); 
        if(response.code >= 400){
            console.log("Error Mermas - 400:", response, recurso);
        }else{
            if (arrDta.length > 0){
                setDestinos([...arrDta]);
            }else{
                setDestinos([]);          
            }      
        }        
    } 

    const GuardaDestino = async () =>{
        
        setSHCarga(true);

        const bdy = {
            Pais: "CL",
            Anno: props.formData.Anno,
            Mes: props.formData.Mes,
            Centro: props.formData.Centro,
            Almacen: props.formData.Almacen,
            NRO_SOLICITUD : props.NroSolicitud,
            ID_DESTINO : parseInt(cmbDestino)
        };  
        //console.log("GuardaDestino ", bdy);       
        const recurso = `${env.REACT_APP_API_URL}/api/MermaDestinoLi`;
        const response = await httpApiPostText(recurso, "POST", {
            'Content-Type': 'application/json',
            'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
            'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
        }, bdy);
        setSHCarga(false); 
              
        const arrDta = await JSON.parse(response.message); 

        if(response.code >= 400){
            console.log("Error Mermas - 400:", response, recurso);
        }else{
            if (arrDta.length > 0){
                setDestinos([...arrDta]);
            }else{
                setDestinos([]);          
            }       
        }
        
        props.HandlerClickOk();
    }     
    
    useEffect(()=>{
        if(props.Show){
            consultaDestino();
        }
    },[props.Show]);
    
 return (
      <div>
        <Modal show={props.Show} centered={true} size='lg' >
            <Modal.Header  className={`bg-${icn}`}  >
                <Modal.Title className='h3 text-center text-light'>
                    {                        
                        props.Title
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>                                
                    <select  className="form-select" id="sizeTag" aria-label="Default select example" value={cmbDestino} onChange={(evnt: any) => setCmbDestino(evnt.target.value)}>
                        <option value={`0`}>{`Seleccione un destino`}</option>    
                        {
                            destinos.map((item : any, idx:number)=><option key={idx} value={`${item.ID_DESTINO}`}>{`${item.DESCRIPCION_DEST}`}</option>)
                        }
                    </select>
                </div>
            </Modal.Body>                
            <Modal.Footer >
                <div className='w-100 '>
                    <div className='row justify-content-center'>
                        {
                            (props.BtnOkName) 
                                ?
                                <div className='col-md-12 col-lg-3 '>
                                    <Button type="button" className="btn btn-success w-100" disabled={cmbDestino === `0`} onClick={GuardaDestino}>
                                        {props.BtnOkName}
                                    </Button>                            
                                </div> 
                                : <div></div>
                        }      
                        {
                            (props.BtnNokName) 
                                ? 
                                <div className='col-md-12 col-lg-3 '>
                                    <Button type="button" className="btn btn-danger w-100" onClick={props.HanlerdClickNok}>
                                        {props.BtnNokName}
                                    </Button>                        
                                </div>                         
                                : <div></div>
                        }   
                    </div>
                  
                </div>
                                     
            </Modal.Footer>
        </Modal>
        {/******* Carga masiva *******************************/}          
        <LocalMsgModalSpinner 
            Show={sHCarga}
            text="Un momento por favor, procesando..."
            color="#FF7588"
        />          
      </div>
  );
}

export default ModalAsignarDestino;
